<template>
  <div class="apply">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('remote.crumbs.L1')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_body">
      <div class="apply_bg">
        <img src="/static/img/header.svg" alt="">
        <div class="apply_msg">
          <p>{{$t('remote.crumbs.L1')}}</p>
          <p v-if="isEnLanguage">
            <span>{{ $t('apply.remotePayMsg1') }}</span>
            <span class="msg_place first-a">{{ $t('apply.remotePayMsg2') }}</span><span class="msg_place">{{ $t('apply.remotePayMsg3') }}</span>
            <span class="msg_place first-a">{{ $t('apply.remotePayMsg4') }}</span><span class="msg_place">{{ $t('apply.remotePayMsg5') }}</span>
            <span class="msg_place first-a">{{ $t('apply.remotePayMsg7') }}</span><span class="msg_place">{{ $t('apply.remotePayMsg8') }}</span>
            <span>{{ $t('apply.remotePayMsg9') }}</span>
          </p>
          <p v-if="isZhLanguage">
            <span>{{ $t('apply.remotePayMsg1') }}</span>
            <span class="msg_place first-a">{{ $t('apply.remotePayMsg2') }}</span><span class="msg_place first-a">{{ $t('apply.remotePayMsg4') }}</span><span class="msg_place">{{ $t('apply.remotePayMsg6') }}</span><span class="msg_place first-a">{{ $t('apply.remotePayMsg7') }}</span><span>{{ $t('apply.remotePayMsg9') }}</span>
          </p>
          <button :disabled="btnStatus" @click="apply">{{ applyStatus !== 0 ? $t('apply.applyed') : $t('apply.apply') }}</button>
        </div>
      </div>

      <div class="apply_introduction">
        <div class="apply_introduction_why">
          <p class="apply_introduction_title">{{ $t('apply.title') }}</p>
          <div class="apply_introduction_detail">
            <div class="apply_introduction_detail_one detail">
              <img src="./img/img_1.svg" alt="">
              <div class="apply_introduction_detail_one_title introduct">
                <p>1.</p>
                <p>{{ $t('apply.list1') }}</p>
              </div>
            </div>
            <div class="apply_introduction_detail_two detail">
              <img src="/static/img/img_2.svg" alt="">
              <div class="apply_introduction_detail_two_title introduct">
                <p>2.</p>
                <p>{{ $t('apply.list2') }}</p>
              </div>
            </div>
            <div class="apply_introduction_detail_three detail">
              <img src="./img/img_3.svg" alt="">
              <div class="apply_introduction_detail_three_title introduct">
                <p>3.</p>
                <p>{{ $t('apply.list3') }}</p>
              </div>
            </div>
            <div class="apply_introduction_detail_four detail">
              <img src="./img/img_4.svg" alt="">
              <div class="apply_introduction_detail_four_title introduct">
                <p>4.</p>
                <p>{{ $t('apply.list4') }}</p>
              </div>
            </div>
            <div class="apply_introduction_detail_five detail">
              <img src="./img/img_5.svg" alt="">
              <div class="apply_introduction_detail_five_title introduct">
                <p>5.</p>
                <p>{{ $t('apply.list5') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="apply_introduction_how">
          <p class="apply_remotepay">{{ $t('apply.howtoApply')}}</p>
          <div class="dashed_line"></div>
          <div class="apply_remotepay_details">
            <div class="apply_remotepay_detail detail_one">
              <img src="./img/img_2_1.svg" alt="">
              <p>1.{{ $t('apply.method1')}}</p>
            </div>
            <div class="apply_remotepay_detail detail_two">
              <img src="./img/img_2_2.svg" alt="">
              <p>2.{{ $t('apply.method2')}}</p>
            </div>
            <div class="apply_remotepay_detail detail_three">
              <img src="./img/img_2_3.svg" alt="">
              <p>3.{{ $t('apply.method3')}}</p>
            </div>
            <div class="apply_remotepay_detail detail_four">
              <img src="./img/img_2_4.svg" alt="">
              <p>4.{{ $t('apply.method4')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from 'config'
import qs from 'qs'
export default {
  data () {
    return {
      applyStatus: '',
      btnStatus: true,
      isEnLanguage: '',
      isZhLanguage: ''
    }
  },
  created () {
    if (window.localStorage.getItem('lang')) {
      if (JSON.parse(window.localStorage.getItem('lang')).value === 'en') {
        this.isEnLanguage = true
        this.isZhLanguage = false
      } else {
        this.isEnLanguage = false
        this.isZhLanguage = true
      }
    } else {
      this.isEnLanguage = false
      this.isZhLanguage = true
    }
    this.getApplyStatus()
  },
  methods: {
    getApplyStatus () {
      axios.get(`${config.oHost}/remotepay/remotepay_check`, {
      // axios.get('http://192.168.0.130:6510/remotepay/remotepay_check', {
        params: {
          format: 'cors'
        }
      }).then(res => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.applyStatus = data.data.remotepay_status
          if (this.applyStatus === 0) {
            this.btnStatus = false
          } else if (this.applyStatus === 1) {
            this.$router.push({ name: 'apply' })
          } else if (this.applyStatus === 2) {
            this.btnStatus = true
          }
        } else {
          this.$message.error(data.resperr)
        }
      })
    },
    apply () {
      this.btnStatus = true
      let params = {
        src: 'mms',
        format: 'cors'
      }
      axios.post(`${config.oHost}/remotepay/apply/create`, qs.stringify(params)).then(res => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.getApplyStatus()
          this.$message.success(this.$t('apply.applyed'))
        } else {
          this.btnStatus = false
          this.$message.error(data.resperr)
        }
      })
    },
  },
}
</script>

<style lang="scss">
  .apply {
    .banner_wrapper {
      .el-breadcrumb__item__inner {
        color: #262424 !important;
      }
    }
    .main_body {
      margin-left: 26px;
      margin-top: 26px;
      margin-right: 25px;
      background-color: #FFFFFF;
      .apply_bg {
        width: 100%;
        position: relative;
        img {
          width: 100%;
        }
        .apply_msg {
          position: absolute;
          top: 46px;
          left: 90px;
          p:nth-child(1) {
            height: 50px;
            font-size: 36px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
            margin-bottom: 3px;
          }
          p:nth-child(2) {
            font-family:PingFangSC-Light,PingFang SC;
            height: 48px;
            font-size: 16px;
            font-weight: 300;
            line-height: 28px;
            width: 62%;
            color: #FFFFFF;
            margin-bottom: 34px;
            .msg_place {
              font-style: italic;
              white-space: wrap;
            }
            .first-a {
              color: #FFFFFF;
              font-weight: 700;
              font-size: 20px;
            }
          }
          button {
            width: 140px;
            height: 44px;
            border: none;
            border-radius: 8px;
            color: #FFFFFF;
            background-color: #FF8100;
            line-height: 44px;
            text-align: center;
            font-size: 17px;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
      .apply_introduction {
        margin-left: 29px;
        margin-right: 30px;
        .apply_introduction_why {
          .apply_introduction_title {
            color: #27282B;
            margin-top: 30px;
            height: 28px;
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
            margin-bottom: 40px;
          }
          .apply_introduction_detail {
            display: flex;
            justify-content: space-between;
            .detail {
              height: 198px;
              width: 206px;
              text-align: center;
            }
            img {
              height: 130px;
              width: 130px;
            }
            .introduct {
              display: flex;
              color: #030303;
              justify-content: center;
              P:nth-child(1) {
                font-size: 32px;
                line-height: 32px;
                height: 32px;
                font-family:DIN-LightItalic,DIN;
                font-weight:normal;
                font-style: italic;
                margin-top: 10px;
                margin-right: 5px;
              }
              P:nth-child(2) {
                font-size: 15px;
                height: 42px;
                line-height: 21px;
                margin-top: 22px;
              }
            }
          }
        }
        .apply_introduction_how {
          position: relative;
          padding-bottom: 42px;
          margin-bottom: 19px;
          .apply_remotepay {
            color: #27282B;
            margin-top: 50px;
            height: 28px;
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
            margin-bottom: 40px;
          }
          .dashed_line {
            width: 75%;
            height: 0;
            border: 1px dashed #A7A9AE;
            margin-top: 40px;
            margin-left: 12.5%;
            margin-right: 12.5%;
            position: absolute;
          }
          .apply_remotepay_details {
            display: flex;
            .apply_remotepay_detail {
              z-index: 1;
              flex: 1;
              text-align: center;
              img {
                height: 80px;
                width: 80px;
              }
              p {
                height: 21px;
                font-size: 15px;
                color: #030303;
                line-height: 21px;
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1440px) {
    .apply {
      .main_body {
        .apply_bg {
          width: 100%;
          position: relative;
          img {
            width: 100%;
          }
          .apply_msg {
            position: absolute;
            top: 20px;
            left: 70px;
            p:nth-child(1) {
            height: 50px;
            font-size: 30px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
            margin-bottom: 3px;
          }
            p:nth-child(2) {
              height: 48px;
              font-size: 20px;
              font-weight: 300;
              line-height: 28px;
              color: #FFFFFF;
              margin-bottom: 24px;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1300px) {
    .apply {
      .main_body {
        .apply_bg {
          width: 100%;
          position: relative;
          img {
            width: 100%;
          }
          .apply_msg {
            position: absolute;
            top: 5px;
            left: 70px;
            p:nth-child(1) {
              height: 50px;
              font-size: 25px;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 50px;
              margin-bottom: 3px;
            }
            p:nth-child(2) {
              height: 48px;
              font-size: 15px;
              font-weight: 300;
              line-height: 28px;
              color: #FFFFFF;
              margin-bottom: 24px;
            }
            button:nth-child(3) {
              font-size: 15px;
              height: 40px;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// apply.vue?dde4db94